import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=936a3a96&scoped=true&"
var script = {}
import style0 from "./Policy.vue?vue&type=style&index=0&id=936a3a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936a3a96",
  null
  
)

export default component.exports